import fetch from '../utils/fetch';
import busyActionFactory from '../busy';
import uuid from 'uuid/v4';
import { setToast } from './app';
import { emailURL } from 'endpoints';
const stringTemplateParser = require( 'string-template-parser' );
import { DEFAULT_SOURCE_LOCALE_CODE } from '../utils/constants';
import { routeHistory } from '@nackle/biw-web-router';

/*******************************************************************************
 *
 *   1. Default State
 *   2. Action Types
 *   3. Action Creators
 *   4. Reducers
 *
 */

/*******************************************************************************
 *  1. Default State
 */

export const initialState = {
    components: [],
    componentDrawerOpen: false,
	translationDrawerOpen: false,
    locale: DEFAULT_SOURCE_LOCALE_CODE,
    inputs: [ {
        id: uuid(),
        code: 'title',
        value: '',
        required: true,
        type: 'string',
        toTranslate: true,
        toOverride: true
    }, {
        id: uuid(),
        code: 'subject',
        value: '',
        required: true,
        type: 'string',
        toTranslate: true,
        toOverride: true
    }, {
        id: uuid(),
        code: 'previewText',
        value: '',
        required: true,
        type: 'string',
        toTranslate: true,
        toOverride: true
    } ],
    recipients: [],
    busySendingTranslations: false
};

/*******************************************************************************
 *  2. Action Types
 */

export const ADD_EMAIL_COMPONENT = 'ADD_EMAIL_COMPONENT';
export const BUSY_FETCHING_COMPONENT = 'BUSY_FETCHING_COMPONENT';
export const BUSY_DELETING_EMAIL = 'BUSY_DELETING_EMAIL';
export const SEND_EMAIL_RESPONSE = 'SEND_EMAIL_RESPONSE';
export const BUSY_SENDING_EMAIL = 'BUSY_SENDING_EMAIL';
export const SAVE_EMAIL_RESPONSE = 'SAVE_EMAIL_RESPONSE';
export const BUSY_SAVING_EMAIL = 'BUSY_SAVING_EMAIL';
export const UPDATE_EMAIL_PROPS = 'UPDATE_EMAIL_PROPS';
export const UPDATE_COMPONENT_ORDER = 'UPDATE_COMPONENT_ORDER';
export const UPDATE_INPUTS = 'UPDATE_INPUTS';
export const BUSY_FETCHING_EMAIL = 'BUSY_FETCHING_EMAIL';
export const BUSY_SENDING_TRANSLATIONS = 'BUSY_SENDING_TRANSLATIONS';
export const UPDATE_SELECTED_EMAIL = 'UPDATE_SELECTED_EMAIL';
export const DELETE_SELECTED_EMAIL = 'DELETE_SELECTED_EMAIL';
export const TOGGLE_COMPONENT_DRAWER = 'TOGGLE_COMPONENT_DRAWER';
export const UPDATE_PROPS = 'UPDATE_PROPS';
export const ADD_USER = 'ADD_USER';
export const DELETE_USER = 'DELETE_USER';
export const REMOVE_COMPONENT = 'REMOVE_COMPONENT';
export const TRANSLATE_EMAIL_RESPONSE = 'TRANSLATE_EMAIL_RESPONSE';
export const UPDATE_SEND_EMAIL_PROPS = 'UPDATE_SEND_EMAIL_PROPS';
export const COPY_EMAIL = 'COPY_EMAIL';
export const DELETE_EMAIL = 'DELETE_EMAIL';
export const ADD_COMPONENT_CONDITIONS = 'ADD_COMPONENT_CONDITIONS';
export const REMOVE_COMPONENT_CONDITIONS = 'REMOVE_COMPONENT_CONDITIONS';
export const UPDATE_COMPONENT_CONDITIONS = 'UPDATE_COMPONENT_CONDITIONS';
export const TOGGLE_TRANSLATION_CONFIG_DRAWER = 'TOGGLE_TRANSLATION_CONFIG_DRAWER';
export const UPDATE_COMPONENT_CONDITIONS_TEST_VALUE = 'UPDATE_COMPONENT_CONDITIONS_TEST_VALUE';

/*******************************************************************************
 *  3. Action Creators
 */

export const addEmailComponent = ( data ) => {
    return {
        type: ADD_EMAIL_COMPONENT,
        data
    };
};

export const removeComponent = ( componentId ) => {
    return {
        type: REMOVE_COMPONENT,
        componentId
    };
};

export const sendEmailResponse = ( data ) => {
    return {
        type: SEND_EMAIL_RESPONSE,
        data
    };
};

export const translateEmailResponse = ( data ) => {
    return {
        type: TRANSLATE_EMAIL_RESPONSE,
        data
    };
};

export const saveEmailResponse = ( data ) => {
    return {
        type: SAVE_EMAIL_RESPONSE,
        data
    };
};

export const updateEmailProps = ( key, value, subsection ) => {
    return {
        type: UPDATE_EMAIL_PROPS,
        subsection,
        data: {
            [ key ]: value
        }
    };
};

export const updateSendEmailProps = ( code, value, index, subsection ) => {
    let rawContentState;
    if ( typeof value === 'object' ) {
        rawContentState = value.rawContentState;
        value = value.value;
    }

    return {
        type: UPDATE_SEND_EMAIL_PROPS,
        code,
        value,
        rawContentState,
        index,
        subsection
    };
};

export const addUser = () => {
    return {
        type: ADD_USER
    };
};

export const deleteUser = ( id ) => {
    return {
        type: DELETE_USER,
        id
    };
};

export const updateInputs = ( obj, value, prop, error ) => {
    if ( value === 'true' || value === 'false' ) {
        value = 'true' ? true : false; //eslint-disable-line
    }
        
    const data = prop === 'richText' ? { value: value.value, rawContentState: value.rawContentState } : { [ prop ]: value };

    return {
        type: UPDATE_INPUTS,
        data: Object.assign( {}, obj, data, { error: error } )
    };
};

export const updateComponentOrder = ( components ) => {
    return {
        type: UPDATE_COMPONENT_ORDER,
        components
    };
};

export const updateProps = ( componentId, propKey, obj, inputId ) => {
    return {
        type: UPDATE_PROPS,
        data: {
            componentId,
            propKey,
            obj: Object.assign( {}, obj, { inputId } )
        }
    };
};

export const handleDrawer = ( value ) => {
    return {
        type: TOGGLE_COMPONENT_DRAWER,
        value
    };
};

export const handleTranslationDrawer = ( value ) => {
    return {
        type: TOGGLE_TRANSLATION_CONFIG_DRAWER,
        value
    };
};

export const addConditional = ( componentId ) => {
    return {
        type: ADD_COMPONENT_CONDITIONS,
        componentId 
    };
};

export const removeConditional = ( componentId, index ) => {
    return {
        type: REMOVE_COMPONENT_CONDITIONS,
        componentId,
        index
    };
};

export const updateConditional = ( componentId, index, value, key ) => {
    return {
        type: UPDATE_COMPONENT_CONDITIONS,
        componentId,
        index,
        value,
        key
    };
};

export const updateConditionalTestValue = ( recipientIndex, key, value ) => {
    return {
        type: UPDATE_COMPONENT_CONDITIONS_TEST_VALUE,
        recipientIndex,
        key,
        value
    };
};

export const updateSelectedEmail = ( data ) => {
    return {
        type: UPDATE_SELECTED_EMAIL,
        data
    };
};

export const deleteSelectedEmail = () => {
    return {
        type: DELETE_SELECTED_EMAIL
    };
};

export const deleteEmailResponse = ( data ) => {
    return {
        type: DELETE_EMAIL,
        data
    };
};

export const copyEmail = () => {
    return {
        type: COPY_EMAIL
    };
};

export const busySendingForTranslations = ( flag ) => {
    return {
        type: BUSY_SENDING_TRANSLATIONS,
        flag
    };
};

const busyDeletingEmail = busyActionFactory( BUSY_DELETING_EMAIL );
export const deleteEmail = ( emailId ) => {
    return async ( dispatch, getState ) => {

        busyDeletingEmail( true );

        try {

            const deleteRequest = await fetch( `${ emailURL }/${ emailId }`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                }
            } );

            const deleteResponse = await deleteRequest.json();

            dispatch( deleteEmailResponse( deleteResponse ) );

            dispatch( routeHistory.push( '/' ) );
        } catch ( err ) {
            console.error( err );
            busyDeletingEmail( false );
        }
    };
};

const busyFetchingComponent = busyActionFactory( BUSY_FETCHING_COMPONENT );
export const fetchNewEmailComponent = ( namespace, name ) => {
    return async ( dispatch, getState ) => {

        busyFetchingComponent( true );

        try {

            const componentRequest = await fetch( `${ emailURL }/components/${ namespace }/${ name }`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            } );

            const componentResponse = await componentRequest.json();

            dispatch( addEmailComponent( componentResponse ) );
            dispatch( busyFetchingComponent( false ) );

        } catch ( err ) {

            console.error( err );
            busyFetchingComponent( false );

        }

    };
};

const busySendingEmail = busyActionFactory( BUSY_SENDING_EMAIL );
export const sendEmail = ( emailId ) => {

    return async ( dispatch, getState ) => {
        const state = getState();

        busySendingEmail( true );

        try {

            const sendRequestObj = {
                fromAddress: 'cpdtesting@biworldwide.com',
                recipients: state.builder.recipients.map( recipient => {
                    return {
                        toAddress: recipient.toAddress,
                        inputs: recipient.inputs.reduce( ( sendInputs, cur ) => {
                            sendInputs[ cur.code ] = cur.value;
                            return sendInputs;
                        }, {} ),
                        conditionals: recipient.conditionals.reduce( ( sendConditionals, cur ) => {
                            sendConditionals[ cur.a ] = cur.value;
                            return sendConditionals;
                        }, {} ),
                        rawContentStates: recipient.inputs.reduce( ( sendRawStateContents, cur ) => {
                            if ( cur.rawContentState && Object.keys( cur.rawContentState ).length > 0 ) {
                                sendRawStateContents[ cur.code ] = cur.rawContentState;
                            }
                            return sendRawStateContents;
                        }, {} )
                    };
                } )
            };

            const url = emailURL.replace( 'v1', 'v2' );
            const sendRequest = await fetch( `${ url }/${ emailId }/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify( sendRequestObj )
            } );

            const sendResponse = await sendRequest.json();

            dispatch( sendEmailResponse( sendResponse ) );
            dispatch( busySendingEmail( false ) );

        } catch ( err ) {

            console.error( err );
            dispatch( busySendingEmail( false ) );

        }

    };

};

const busySavingEmail = busyActionFactory( BUSY_SAVING_EMAIL );
export const saveEmail = () => {

    return async ( dispatch, getState ) => {

        busySavingEmail( true );

        try {

            const emailId = getState().builder.id || uuid();

            const emailRequestObj = {
                id: emailId,
                layout: getState().builder.layout,
                product: getState().builder.product,
                name: getState().builder.name,
                type: getState().builder.type,

                components: getState().builder.components.map( component => {
                    return {
                        name: component.name,
                        namespace: component.namespace,
                        props: Object.keys( component.props ).reduce( ( flatProps, propKey ) => {
                            const input = getState().builder.inputs.find( input => input.id === component.props[ propKey ].inputId );
                            flatProps[ propKey ] = input ? `\${ref:inputs.${ input.code }}` : '';
                            return flatProps;
                        }, {} ),
                        conditionals: component.conditionals
                    };
                } )
            };

            // For old emails to have toOverride as true we have to update on each and every save.
            getState().builder.inputs.map( input => {
                if ( [ 'title', 'subject', 'previewText' ].includes( input.code ) ) {
                    input.toOverride = true;
                    return input;
                }
            } );

            const locale = getState().builder.locale;
            const inputsRequestObj = {
                emailId,
                locale,
                inputs: getState().builder.inputs
            };

            const [ emailRequest, inputsRequest ] = await Promise.all( [
                fetch( `${ emailURL }`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify( emailRequestObj )
                } ),
                fetch( `${ emailURL }/${ emailId }/inputs`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify( inputsRequestObj )
                } )
            ] );


            const emailResponse = await emailRequest.json();
            const inputsResponse = await inputsRequest.json();

            if ( !getState().builder.id ) {
                routeHistory.push( `/email/${ emailId }` );
            }

            dispatch( saveEmailResponse( { locale, email: emailResponse, inputs: inputsResponse } ) );

        } catch ( err ) {

            console.error( err );

        }

    };

};

export const sendForTranslations = ( translationConfigList ) => {

    return ( dispatch, getState ) => {

        const requestBody = {
            ...getState().builder,
            customOptions: translationConfigList
        };

        dispatch( busySendingForTranslations( true ) );

        fetch( `${ emailURL }/translations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( requestBody )
        } )
        .then( response => response.json() )
        .then( async response => {
            if ( !response || !response.success ) {
                dispatch( busySendingForTranslations( false ) );
                console.error( response.message );
                dispatch( setToast( response.message, 'ERROR' ) );
            } else {
                dispatch( translateEmailResponse( response ) );
                dispatch( busySendingForTranslations( false ) );
                dispatch( setToast( `Translation for email ${ requestBody.name } submitted successfully`, 'Success' ) );
                dispatch( handleTranslationDrawer( false ) );
            }
        } )
        .catch( ( error ) => {
            console.log( error );
            dispatch( busySendingForTranslations( false ) );
        } );

    };

};

const busyFetchingEmail = busyActionFactory( BUSY_FETCHING_EMAIL );
export const emailChange = ( emailId, locale = DEFAULT_SOURCE_LOCALE_CODE ) => {
    return async ( dispatch, getState ) => {

        busyFetchingEmail( true );

        try {

            if ( emailId ) {
                const [ emailRequest, inputsRequest ] = await Promise.all( [
                    fetch( `${ emailURL }/${ emailId }`, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    } ),
                    fetch( `${ emailURL }/${ emailId }/inputs`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'locale': locale
                        }
                    } )
                ] );

                const emailResponse = await emailRequest.json();
                const inputsResponse = await inputsRequest.json();

                dispatch( updateSelectedEmail( { locale, email: emailResponse, inputs: inputsResponse } ) );
            } else {
                dispatch( deleteSelectedEmail() );
            }
        } catch ( err ) {

            console.error( 'Error in emailChange', err, err.stack );

        }

    };
};

export const getObjectPath = ( prop ) => {
    return '${' + `ref:inputs.${ prop }${ Math.floor( ( Math.random() * 1000 ) + 1 ) }` + '}';
};

/*******************************************************************************
 *  4. Reducers
 */

export default function emailData( state = initialState, action ) {

    let newState;

    switch ( action.type ) {

        case DELETE_USER:
            newState = Object.assign( {}, state );
            newState.recipients.splice( action.id, 1 );
            newState.recipients = [ ...newState.recipients ];
            return newState;

        case ADD_USER:
            newState = Object.assign( {}, state );
            const addRecipients = Object.keys( state.inputs ).map( input => {
                    return {
                        allowRichText: state.inputs[ input ].allowRichText || false,
                        rawContentState: state.inputs[ input ].rawContentState || {},
                        code: state.inputs[ input ].code,
                        value: state.inputs[ input ].value
                    } ;
                } );


            const conditionals = [];
            
            state.components.map( ( component ) => {
                if ( component.conditionals ) {
                    component.conditionals.map( ( conditional ) => {
                        conditionals.push( {
                            name: conditional.componentName,
                            a: conditional.a,
                            value: conditional.b
                        } );
                    } );
                }
            } );

            const userObject = { toAddress: '', inputs: [ ...addRecipients ], conditionals: [ ...conditionals ] };

            if ( Object.prototype.hasOwnProperty.call( newState, 'recipients' ) ) {
                newState.recipients = [
                    ...state.recipients,
                    { ...userObject }
                ];
            } else {
                newState.recipients = [
                    { ...userObject }
                ];
            }
            return newState;

        case ADD_EMAIL_COMPONENT:
            const newComponent = { ...action.data.component, id: uuid() };
            newState = {
                ...state,
                inputs: Object.keys( newComponent.props ).reduce( ( newInputs, cur ) => {
                    const inputId = uuid();
                    newComponent.props[ cur ].inputId = inputId;
                    newInputs.push( {
                        ...newComponent.props[ cur ],
                        code: cur,
                        id: inputId
                    } );
                    return newInputs;
                }, state.inputs ),
                componentDrawerOpen: false
            };
            newState.components = [ ...state.components, newComponent ];
            return newState;

        case REMOVE_COMPONENT:
            const componentToRemove = state.components.find( component => component.id === action.componentId );
            const inputIds = Object.keys( componentToRemove.props ).map( prop => {
                return componentToRemove.props[ prop ].inputId;
            } );
            return {
                ...state,
                components: state.components.filter( component => component.id !== action.componentId ),
                inputs: state.inputs.filter( input => !inputIds.includes( input.id ) )
            };

        case UPDATE_EMAIL_PROPS:
            newState = Object.assign( {}, state );
            switch ( action.subsection ) {
                case 'metadata':
                    newState.metadata = {
                        ...state.metadata,
                        ...action.data
                    };
                    break;
                case 'inputs':
                    newState.inputs = {
                        ...state.inputs,
                        ...action.data
                    };
                    break;
                default:
                    newState = {
                        ...state,
                        ...action.data
                    };
                    break;
            }
            return newState;

        case UPDATE_COMPONENT_ORDER:
            return {
                ...state,
                components: action.components
            };

        case UPDATE_SEND_EMAIL_PROPS:
            newState = Object.assign( {}, state );

            if ( action.subsection === 'inputs' ) {
                const updatedInputs = newState.recipients[ action.index ].inputs.map( input => {
                    if ( input.code === action.code ) {
                        return {
                            code: action.code,
                            value: action.value,
                            allowRichText: input.allowRichText || false,
                            rawContentState: action.rawContentState || {}
                        };
                    } else {
                        return input;
                    }
                } );

                newState.recipients[ action.index ].inputs = updatedInputs;
            } else if ( action.subsection === 'conditionals' ) {
                const updateConditionals = newState.recipients[ action.index ].conditionals.map( conditional => {
                    if ( conditional.a === action.code ) {
                        return {
                            name: conditional.name,
                            a: action.code,
                            value: action.value
                        };
                    } else {
                        return conditional;
                    }
                } );

                newState.recipients[ action.index ].conditionals = updateConditionals;
            } else {
                newState.recipients[ action.index ].toAddress = action.value;
            }
            return {
                ...newState
            };

        case UPDATE_INPUTS:
            return {
                ...state,
                inputs: state.inputs.map( input => {
                    if ( input.id === action.data.id ) {
                        return action.data;
                    } else {
                        return input;
                    }
                } )
            };

        case UPDATE_PROPS:
            return {
                ...state,
                components: state.components.map( component => {
                    if ( component.id === action.data.componentId ) {
                        const newComponent = Object.assign( {}, component );
                        newComponent.props = Object.keys( newComponent.props ).reduce( ( newProps, propKey ) => {
                            if ( propKey === action.data.propKey ) {
                                newProps[ propKey ] = Object.assign( {}, newComponent.props[ propKey ], action.data.obj );
                            } else {
                                newProps[ propKey ] = newComponent.props[ propKey ];
                            }
                            return newProps;
                        }, {} );
                        return newComponent;
                    } else {
                        return component;
                    }
                } )
            };

        case SAVE_EMAIL_RESPONSE:
        case UPDATE_SELECTED_EMAIL:

            newState = {
                ...action.data.email,
                ...action.data.inputs,
                locale: action.data.locale
            };

            newState.inputs = newState.inputs.map( input => {
                return {
                    ...input,
                    id: uuid()
                };
            } );

            // this crazy mess is taking object-path notation like ${ref:inputs.welcomeMessages} and creating the relationship between inputs and component.props via a shared uuid
            newState.components = newState.components.map( component => {
                return {
                    ...component,
                    id: uuid(),
                    props: Object.keys( component.props ).reduce( ( newProps, cur ) => {
                        newProps[ cur ] = {
                            required: component.props[ cur ].required,
                            type: component.props[ cur ].type,
                            name: component.name
                        };

                        let objectPath = null;
                        if ( !component.props[ cur ].objectPath ) {
                            objectPath = getObjectPath( cur );
                            newState.inputs.push( {
                                code: `${ stringTemplateParser.parseStringTemplate( objectPath ).variables[ 0 ].name.split( ':' )[ 1 ].split( '.' )[ 1 ] }`,
                                id: uuid(),
                                required: component.props[ cur ].required,
                                toOverride: component.props[ cur ].toOverride || false,
                                toTranslate: component.props[ cur ].toTranslate || false,
                                allowRichText: component.props[ cur ].allowRichText || false,
                                rawContentState: component.props[ cur ].rawContentState || {},
                                type: component.props[ cur ].type,
                                value: ''
                            } );
                        } else {
                            objectPath = component.props[ cur ].objectPath;
                        }

                        const parsedObjectPath = stringTemplateParser.parseStringTemplate( objectPath );
                        const inputCode = parsedObjectPath.variables[ 0 ].name.split( ':' )[ 1 ].split( '.' )[ 1 ];
                        const emailInput = newState.inputs.find( input => input.code === inputCode );
                        if ( emailInput ) {
                            newProps[ cur ].inputId = emailInput.id;
                        } else {
                            newProps[ cur ].inputId = uuid();
                        }
                        return newProps;
                    }, {} )
                };
            } );

            return newState;

        case DELETE_SELECTED_EMAIL:
            newState = initialState;
            return newState;

        case TOGGLE_COMPONENT_DRAWER:
            return {
                ...state,
                componentDrawerOpen: action.value
            };
        case TOGGLE_TRANSLATION_CONFIG_DRAWER:
            return {
                ...state,
                translationDrawerOpen: action.value
            };
        case COPY_EMAIL:
            return {
                ...state,
                id: '',
                emailId: '',
                name: ''
            };
        case DELETE_EMAIL:
            return {
                ...state
            };
        
        case ADD_COMPONENT_CONDITIONS:
            return {
                ...state,
                components: state.components.map( component => {
                    if ( component.id === action.componentId ) {
                        const newConditional = { a: '', compare: '', b: '', componentName: component.name };
                        component.conditionals = component.conditionals ? component.conditionals : [];
                        component.conditionals.push( newConditional );
                    }

                    return component;

                } )
            };

        case REMOVE_COMPONENT_CONDITIONS:
            return {
                ...state,
                components: state.components.map( component => {
                    if ( component.id === action.componentId ) {
                        component.conditionals = component.conditionals ? component.conditionals : [];
                        component.conditionals.splice( action.index, 1 );
                    }

                    return component;
                } )
            };

        case UPDATE_COMPONENT_CONDITIONS:
            return {
                ...state,
                components: state.components.map( component => {
                    if ( component.id === action.componentId ) {
                        component.conditionals[ action.index ][ action.key ] = action.value;
                    }

                    return component;
                } )
            };

        case UPDATE_COMPONENT_CONDITIONS_TEST_VALUE: 
            const newComponents = state.components;
            newComponents[ action.componentIndex ].conditionals[ action.conditionalIndex ][ action.key ] = action.value;
            return {
                ...state,
                components: newComponents
            };

        case BUSY_SENDING_TRANSLATIONS:
            return {
                ...state,
                busySendingTranslations: action.flag
            };

        default:
            return state;
    }
}
